export enum DefaultProgramMenuItemOptionEnum {
  ProgramLevel = 'Program Level (All)',
  ClassLevel = 'Class Level (All)',
}
